/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export class Diagnostics {
    #callback;
    constructor(callback) {
        this.#callback = callback;
    }
    async report(message) {
        return this.#callback(message);
    }
}
//# sourceMappingURL=diagnostics.js.map